export default {
  preCheckIn: {
    langName: 'Español',
    steps: {
      reserve: 'Reserva',
      guests: 'Huéspedes',
      confirmation: 'Confirmación',
    },
    step1: {
      title: 'Pre Check-in Online',
      subtitle: 'Ingrese el número de su reserva para iniciar el pre check-in.',
      reserveNumber: 'Número de Reserva',
      continue: 'Continuar',
      errorEmpty: 'Ingrese el número de la reserva',
      errorNotFound: 'Reserva no encontrada o no confirmada.',
    },
    step2: {
      reservationLabel: 'Reserva',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      alreadyDoneTitle: '¡Pre check-in ya realizado!',
      alreadyDoneBody: 'Los datos de los huéspedes de esta reserva ya fueron registrados. Puede actualizar la información a continuación si es necesario.',
      progress: 'Pre check-in en curso: {completed} de {total} huéspedes completaron.',
      hotelRules: 'Reglas del Hotel',
      mainGuestChip: 'Principal — obligatorio para factura',
      additionalAdultChip: 'Adulto adicional',
      childChip: 'Niño',
      addressSection: 'Dirección',
      contactSection: 'Contacto',
      fnrhSection: 'Datos de Registro',
      back: 'Volver',
      previous: '← Anterior',
      next: 'Siguiente →',
      confirm: 'Confirmar Pre Check-in',
      saveGuest: 'Guardar este huésped',
      updateGuest: 'Actualizar este huésped',
      guestConfirmedTitle: 'Datos confirmados',
      requiredError: 'Complete todos los campos obligatorios.',
      fieldRequired: '{field} es obligatorio',
      fields: {
        typeDoc: 'Tipo de documento',
        cpf: 'CPF',
        cpfOptional: 'CPF (opcional)',
        docNumber: 'Número de documento',
        name: 'Nombre completo',
        firstName: 'Nombre',
        lastName: 'Apellido',
        birthDate: 'Fecha de nacimiento',
        gender: 'Sexo',
        nationality: 'Nacionalidad',
        maritalStatus: 'Estado civil',
        profession: 'Profesión',
        originCity: 'Ciudad de origen',
        issuingBody: 'Organismo expedidor',
        zipcode: 'Código postal',
        zipcodePostal: 'Código postal / ZIP',
        address: 'Dirección',
        number: 'Número',
        complement: 'Complemento',
        neighborhood: 'Barrio',
        country: 'País',
        state: 'Estado/Provincia',
        city: 'Ciudad',
        email: 'Correo electrónico',
        cellPhone: 'Celular',
        race: 'Raza/Color',
        disability: 'Discapacidad',
        disabilityDesc: 'Descripción de la discapacidad',
      },
    },
    step3: {
      title: '¡Pre Check-in Realizado!',
      body: 'Los huéspedes fueron vinculados a la reserva #{id}. A su llegada al hotel, el check-in será más rápido porque los datos ya están registrados.',
      registeredGuests: 'Huéspedes registrados:',
      mainGuestLabel: 'Huésped Principal',
    },
    guestLabel: {
      main: 'Principal',
      child: 'Niño {n}',
      adult: 'Adulto {n}',
    },
    genericSubmitError: 'Error al realizar el pre check-in.',
    options: {
      gender: { M: 'Masculino', F: 'Femenino' },
      marital: {
        0: 'Soltero(a)', 1: 'Casado(a)', 2: 'Divorciado(a)', 3: 'Viudo(a)', 4: 'Unión Libre',
      },
      mainDocTypes: { 0: 'CPF', 1: 'Pasaporte', 2: 'RNE (Documento Extranjero)' },
      typeDoc: {
        0: 'CPF', 1: 'RG (Documento Brasileño)', 2: 'CNH (Licencia de Conducir)', 3: 'Pasaporte', 4: 'RNE (Documento Extranjero)', 5: 'Certificado de Nacimiento', 6: 'Otro',
      },
      race: {
        0: 'Blanca', 1: 'Negra', 2: 'Mestiza (Parda)', 3: 'Asiática', 4: 'Indígena', 5: 'No Declarada',
      },
      disability: {
        0: 'Ninguna', 1: 'Física', 2: 'Visual', 3: 'Auditiva', 4: 'Intelectual', 5: 'Múltiple',
      },
    },
  },
}
